
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PassengerTransportationPermissionNameInput extends Vue {
  text: string = "";
  creatingNew: boolean = false;

  @Prop() private value!: string
  @Prop({default: []}) private rules!: any[];
  @Prop() private organizationId: string;

  get name() {
    return this.value;
  }

  set name(value: string) {
    if (!value) {
      this.creatingNew = false;
    }
    this.$emit('input', value);
  }

  get canUseAutocomplete() {
    return this.organizationId && this.organizationPtpNames.length > 0;
  }

  get organizationPtpNames(): string[] {
    return this.$store.getters['organization/organizationPtpNames'](this.organizationId);
  }

  get ptpNames(): string[] {
    let names = this.organizationPtpNames;

    if (!this.text) {
      return names;
    }

    const search = this.text.toLowerCase();
    names = names.filter(n => n.toLowerCase().startsWith(search));

    if (names.length === 0) {
      names.push(this.text);
      this.creatingNew = true;
    } else {
      this.creatingNew = false;
    }
    return names;
  }
}
